export const mapArrayValues = <T extends string | number>(
    elements: readonly T[] | undefined,
    mapping: Partial<Record<T, T>>,
    keepOriginal: boolean,
): readonly T[] | undefined => {
    const values = elements?.flatMap((element) => {
        const mapped = mapping[element];
        if (mapped !== undefined) {
            return keepOriginal ? [element, mapped] : [mapped];
        }
        return [element];
    });
    return values ? [...new Set(values)] : undefined;
};
